<template lang="html">
  <main>
    <div class="heading">
      <h1>{{ $ml.get(`My account`) }}</h1>
      <app-btn
        @click="logOut"
        icon="exit_to_app"
      >{{ $ml.get(`Logout`) }}</app-btn>
    </div>
    <router-view/>
  </main>

</template>

<script>
export default {
  data() {
    return {

    }
  },
  components : {

  },
  methods : {
    logOut() {
      this.$store.commit('user/logout');
      this.$router.push({ path: '/' });
      location.reload();
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  padding: 8px;
  flex-direction: column;
  .heading {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

  }
}
</style>
